import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { IsState, SsapData } from '@components/ssap/SsapTypes';
import classnames from 'classnames';

interface IPenaltyPerjuryAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string,
    isAsteriskShown: boolean,
    isFinancialFlow: boolean,
    isState?: IsState
}

const PenaltyPerjuryAttestation = (props: IPenaltyPerjuryAttestation): ReactElement => {
    const {
        actions: { onFieldChange_data },
        data,
        data: {
            legalAttestations: { penaltyOfPerjuryAgreementIndicator },
        },
        formName,
        isAsteriskShown = true,
        isFinancialFlow,
        isState,
    } = props;
    const className = classnames({
        'required-true': isAsteriskShown
    });

    const getTextReplacement = (): React.ReactNode => {
        const messageId = !isFinancialFlow && isState?.MN
            ? 'ssap.sign_and_review.penalty_perjury_non_ff'
            : 'ssap.sign_and_review.penalty_perjury';

        return (
            <span className={className} data-testid={messageId}>
                <FormattedMessage id={messageId} />
            </span>
        );
    };

    return (
        <UniversalInput
            label={{
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: getTextReplacement(),
                },
            }}
            inputData={{
                isInputRequired: true,
                classes: ['disp-styl'],
                type: INPUT_TYPES.CHECKBOX,
                name: 'penaltyOfPerjuryAgreementIndicator',
                checked: penaltyOfPerjuryAgreementIndicator,
                value: penaltyOfPerjuryAgreementIndicator,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: ['legalAttestations'],
            }}
            errorClasses={['margin-l-0']}
            inputActions={{
                onFieldChange: onFieldChange_data,
            }}
            underFormControl
            parentForm={{ name: formName }}
        />
    );
};

export default PenaltyPerjuryAttestation;